import { track } from '../facade';

const dispatch = (category, action, label=null, value=null) => track(action, {
  category,
  label,
  value
});

export const trackFilterChange = (variant, filterName, filterValue) => dispatch(variant, 'Updating Filter', `${filterName} - ${filterValue}`);



// WEBPACK FOOTER //
// ./src/client/js/analytics/category/filter.js